import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://www.newzealandfern.com";

/**
 * Injects a <link rel="canonical"> tag into <head> based on the current route.
 * Prevents duplicate-content issues across routes and query-string variants.
 */
export default function CanonicalHead() {
  const { pathname } = useLocation();

  useEffect(() => {
    const canonical = `${BASE_URL}${pathname === "/" ? "" : pathname}`.replace(/\/+$/, "") || BASE_URL;

    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = canonical;

    return () => {
      link?.remove();
    };
  }, [pathname]);

  return null;
}
